<div class="admin-settings core-screen">
  <div class="title-bar">
    @if (!embeddedInCabinetPage()) {
    <h1 class="core-title">{{ 'dashboard.settings.title' | translate }}</h1>
    }
    <button type="button" class="add-button" (click)="logout()">
      {{ 'dashboard.settings.logout' | translate }}
    </button>
  </div>
  <div class="settings-list">
    @if (canEditMyEmployeeProfile) {
    <button type="button" class="settings-row" (click)="goToMyEmployeeProfile()">
      <span class="settings-row__label">
        {{ 'STAFF.CABINET.SETTINGS.EDIT_MY_EMPLOYEE_PROFILE' | translate }}
      </span>
      <img
        src="/icons/arrow-right.svg"
        alt=""
        class="settings-row__arrow"
        width="24"
        height="24"
      />
    </button>
    }

    <button type="button" class="settings-row" (click)="goToClient()">
      <span class="settings-row__label">
        {{ 'STAFF.CABINET.SETTINGS.SWITCH_TO_CLIENT' | translate }}
      </span>
      <img
        src="/icons/arrow-right.svg"
        alt=""
        class="settings-row__arrow"
        width="24"
        height="24"
      />
    </button>

    @if (isWeb) {
    <p class="settings-hint">{{ 'STAFF.CABINET.SETTINGS.PRINTERS_HINT' | translate }}</p>
    } @else {
    <button
      type="button"
      class="settings-row"
      (click)="goToPrinters()"
    >
      <span class="settings-row__label">{{ 'dashboard.tabs.printers' | translate }}</span>
      <img
        src="/icons/arrow-right.svg"
        alt=""
        class="settings-row__arrow"
        width="24"
        height="24"
      />
    </button>
    }
  </div>

  <lib-cabinet-app-version class="admin-settings__app-version" variant="staff" />
</div>
